import React from "react";
import Bugsnag from "@bugsnag/js";
import { Alert } from "antd";
import { bugsnagInit } from "@aspen/libs/index";

interface IProps {
  children: React.ReactNode;
}
interface IState {
  hasError: boolean;
  onLine: boolean;
}
let ErrorBoundary;

if (process.env.NODE_ENV == "production") {
  bugsnagInit();
  // @ts-ignore
  ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);
}

// 异常上报
class WithLogging extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      onLine: true
    };
  }
  componentDidMount() {
    window.addEventListener("offline", () => {
      this.setState({
        onLine: false
      });
    });
    window.addEventListener("online", () => {
      this.setState({
        onLine: true
      });
    });
    // Error log statistic
    window.addEventListener("error", function onError(e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      // Ignore ResizeObserver error
      console.error("window.addEventListener error:", e);
      if (e.message === "ResizeObserver loop limit exceeded") {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    });
  }
  static getDerivedStateFromError() {
    // 更新 state 使下一次渲染可以显降级 UI
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (String(error).includes("Loading") && String(error).includes("chunk")) {
      window.location.reload();
    }
  }

  componentWillUnmount() {
    this.setState = () => false;
  }

  ErrorView = () => (
    <div>
      <p>Something went wrong.</p>
    </div>
  );

  render(): React.ReactNode {
    if (process.env.NODE_ENV == "production") {
      return (
        <ErrorBoundary FallbackComponent={this.ErrorView}>
          {!this.state.onLine && (
            <Alert
              style={{ textAlign: "center" }}
              showIcon
              message="No network, please check the network link! 😢"
              type="warning"
              closable
            />
          )}
          {this.props.children}
        </ErrorBoundary>
      );
    }
    return (
      <>
        {!this.state.onLine && (
          <Alert
            style={{ textAlign: "center" }}
            showIcon
            message="No network, please check the network link! 😢"
            type="warning"
            closable
          />
        )}
        {this.state.hasError ? (
          <>
            <h1 style={{ textAlign: "center", marginTop: "10%" }}>
              Something went wrong, Please reload again.
            </h1>
            {this.props.children}
          </>
        ) : null}
        {this.props.children}
      </>
    );
  }
}

export { WithLogging };
